export default "__VITE_ASSET__8cc0ddf2__"